import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom/client';
import AppWrapper from './components/AppWrapper';

const App = ({ app }) => {
  return <AppWrapper app={app}></AppWrapper>;
};

export default App;
